import { useBreakpoints } from '@ux/responsive';
import { useStyles } from '@team-griffin/stylr';
import { modifier } from '@ux/style-utils';
import { useTheme, Colorway } from '@uds/theme-utils';
import { Flush } from 'domain/constants/ribbons';
import { Layout } from 'domain/constants/layout';
import findResponsiveItem from 'presentation/utils/findResponsiveItem';
import ribbonPadding from 'presentation/utils/ribbonPadding';
import { duoRibbonWidth } from 'presentation/utils/ribbonWidth';

import { mapFit } from './utils';

export default ({
  colorway,
  loading,
  layout,
  flush,
  duoLayout,
}: {
  colorway: Colorway;
  loading: boolean;
  layout: Layout;
  flush?: Flush | boolean;
  duoLayout?: boolean;
}) => {
  const { theme } = useTheme();
  const { palette, spacing } = theme;
  const { fit } = layout ?? {};
  const breakpoints = useBreakpoints();
  const { isMinSm, isMinMd, isMinLg } = breakpoints;

  const activeFit = findResponsiveItem(breakpoints, fit);

  const padding = ribbonPadding({
    spacing,
    isMinSm,
    isMinLg,
    layout,
    flush,
  });

  const duoLayoutFlex = duoRibbonWidth({
    isMinMd,
    duoLayout,
  });

  return useStyles(
    {
      default: {
        // @ts-ignore: error after upgrading to ux-configs
        root: {
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          ...mapFit(activeFit, true),
          ...padding,
          ...duoLayoutFlex,
        },
        inner: {
          flex: 1,
          flexBasis: 'auto',
          display: 'flex',
          height: 'auto',
        },
        ribbon: {
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        },
      },

      [modifier('colorway', Colorway.PRIMARY_GRADIENT)]: {
        root: {
          backgroundImage: `linear-gradient(to right, ${palette.primary}, ${palette.primaryGradient})`,
        },
      },
    },
    [{ loading }, { colorway }, { isMinSm }, { isMinMd }, { isMinLg }],
  );
};
